import { createFileRoute } from '@tanstack/react-router';

import { AwaitingApprovalPage } from '@/features/auth/components/awaiting-approval-page';

export const Route = createFileRoute('/_awaiting-approval/awaiting-approval')({
  component: AwaitingApprovalPage,
});
